import { date, object, SchemaOf, string } from 'yup';

import { MAX_STRING_LENGTH_YUP_TEMPLATE, REQUIRED_FIELD } from '@/config/text.const';


export type BillingCadenceFormFields = {
  billingCycleStartDate: any;
  changeReasonName: string;
  changeReasonComment: string;
};

export const billingCadenceValidationSchema: SchemaOf<BillingCadenceFormFields> = object().shape({
  billingCycleStartDate: date()
    .required(REQUIRED_FIELD),

  changeReasonName: string()
    .required(REQUIRED_FIELD),

  changeReasonComment: string()
    .max(100, MAX_STRING_LENGTH_YUP_TEMPLATE)
    .required(REQUIRED_FIELD),
});
